"use client";
import { Button } from "@/components/Button/Button";
import { ContentTag } from "@/components/ContentTag/ContentTag";
import { LinkType } from "@/types/baseTypes";
import React from "react";
import styles from "./InfoTextBox.module.scss";
import { FadeIn } from "@/components/Animation";

function InfoTextBox({
  title,
  content,
  link,
}: {
  title: string;
  content: string;
  link: LinkType;
}) {
  return (
    <FadeIn delay={0.3}>
      <div className={styles["info-text-box"]}>
        <p className="card-title-big">{title}</p>
        <ContentTag content={content} />
        {link && link.url && (
          <Button
            type="secondary"
            href={link.url}
            target={link.target}
            aria-label={link.aria_label}
            className="my-0"
            onPointerDown={(e) => e.stopPropagation()}
          >
            {link.title}
          </Button>
        )}
      </div>
    </FadeIn>
  );
}

export default InfoTextBox;
